import { useState } from "react";

import { ProjectDiscoveryConversationsPanel } from "./ProjectDiscoveryConversationsPanel";
import { ProjectDiscoveryDocumentsPanel } from "./ProjectDiscoveryDocumentsPanel";
import { ProjectDiscoveryNotesPanel } from "./ProjectDiscoveryNotesPanel";
import { ProjectMeetingsTab } from "./ProjectMeetingsTab";
import { ContextUsedBlock } from "./ContextUsedBlock";

interface ProjectDiscoveryPanelProps {
  projectId: string;
  contextRefreshKey?: string | number;
}

type DiscoveryTabKey = "meetings" | "documents" | "conversations" | "notes";

const discoveryTabs: { key: DiscoveryTabKey; label: string }[] = [
  { key: "meetings", label: "Meetings" },
  { key: "documents", label: "Documents" },
  { key: "conversations", label: "Conversations" },
  { key: "notes", label: "Notes" },
];

export function ProjectDiscoveryPanel({ projectId, contextRefreshKey }: ProjectDiscoveryPanelProps): JSX.Element {
  const [activeTab, setActiveTab] = useState<DiscoveryTabKey>("documents");
  const [notesRefreshKey, setNotesRefreshKey] = useState<number>(0);

  const handleNotesUpdated = () => {
    setNotesRefreshKey((current) => current + 1);
  };

  return (
    <div className="flex flex-col gap-3">
      <ContextUsedBlock projectId={projectId} refreshKey={contextRefreshKey} />

      <div className="flex flex-wrap items-center gap-2">
        {discoveryTabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`button ${activeTab === tab.key ? "button-primary" : "button-secondary"}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "documents" ? <ProjectDiscoveryDocumentsPanel projectId={projectId} /> : null}
      {activeTab === "meetings" ? <ProjectMeetingsTab projectId={projectId} /> : null}
      {activeTab === "conversations" ? (
        <ProjectDiscoveryConversationsPanel projectId={projectId} onNotesUpdated={handleNotesUpdated} />
      ) : null}
      {activeTab === "notes" ? <ProjectDiscoveryNotesPanel projectId={projectId} refreshKey={notesRefreshKey} /> : null}
    </div>
  );
}
